import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/carBookingData', request)
}

export {get}
